import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { nl } from "date-fns/locale";
import * as React from "react";
import { useEffect, useState } from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import { features } from "../../../../features";
import { moment } from "../../../../utils/moment";
import { renderCalendarHeader } from "../../CalendarHeader";
registerLocale('nl', nl);
export const EventFilters = (param)=>{
    let { filters, locations } = param;
    const config = features().events;
    if (config == 'off') return /*#__PURE__*/ _jsx(_Fragment, {});
    const { locationFilter } = config.overviewPage;
    const [startDate, setStartDate] = useState(filters.from ?? null);
    const [endDate, setEndDate] = useState(filters.to ?? null);
    useEffect(()=>{
        setStartDate(filters.from ?? null);
        setEndDate(filters.to ?? null);
    }, [
        filters.from,
        filters.to
    ]);
    const handleChange = (dates)=>{
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        if (start && end) {
            const rangeFrom = moment(start).startOf('day').toDate();
            const rangeTo = moment(end).endOf('day').toDate();
            filters.updateDateRange(rangeFrom, rangeTo);
        }
    };
    const formatDateRange = ()=>{
        if (startDate && endDate) return `${moment(startDate).format('D MMM')} – ${moment(endDate).format('D MMM YYYY')}`;
        if (startDate) return `${moment(startDate).format('D MMM YYYY')} – ...`;
        return 'Elk moment';
    };
    const hasDateRange = !!(startDate && endDate);
    const clearDateRange = ()=>{
        setStartDate(null);
        setEndDate(null);
        filters.updateDateRange(undefined, undefined);
    };
    const periodFilter = /*#__PURE__*/ _jsxs("div", {
        className: "region-date__select form__item--icon right",
        children: [
            /*#__PURE__*/ _jsx(DatePicker, {
                locale: "nl",
                minDate: new Date(),
                selectsRange: true,
                startDate: startDate ?? undefined,
                endDate: endDate ?? undefined,
                onChange: handleChange,
                placeholderText: "Elk moment",
                value: formatDateRange(),
                dateFormat: "d MMM yyyy",
                id: "rd-date",
                className: "form__input",
                calendarClassName: "calendar",
                popperClassName: "calendar__popper",
                renderCustomHeader: renderCalendarHeader
            }),
            hasDateRange ? /*#__PURE__*/ _jsx("button", {
                type: "button",
                className: "region-date__clear",
                onClick: clearDateRange,
                "aria-label": "Wis datumbereik",
                children: /*#__PURE__*/ _jsx("svg", {
                    width: "16",
                    height: "16",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ _jsx("use", {
                        xlinkHref: "#icon--close"
                    })
                })
            }) : /*#__PURE__*/ _jsx("svg", {
                width: "20",
                height: "20",
                "aria-hidden": "true",
                children: /*#__PURE__*/ _jsx("use", {
                    xlinkHref: "#icon--calendar"
                })
            })
        ]
    });
    const locationFilterElement = locationFilter.kind == 'region' ? /*#__PURE__*/ _jsx("div", {
        className: "region-date__select form__select",
        children: /*#__PURE__*/ _jsxs("select", {
            onChange: (e)=>filters.updateRegion(e.target.value),
            value: filters.regions[0] || '',
            id: "rd-region",
            children: [
                /*#__PURE__*/ _jsx("option", {
                    value: "",
                    children: locationFilter.defaultLabel
                }, "any"),
                locations.sort().map((x, k)=>/*#__PURE__*/ _jsx("option", {
                        value: x,
                        children: k
                    }, x))
            ]
        })
    }) : locationFilter.kind == 'location' ? /*#__PURE__*/ _jsx("div", {
        className: "region-date__select form__select",
        children: /*#__PURE__*/ _jsxs("select", {
            onChange: (e)=>filters.updateLocation(e.target.value),
            value: filters.locations[0] || '',
            id: "rd-region",
            children: [
                /*#__PURE__*/ _jsx("option", {
                    value: "",
                    children: locationFilter.defaultLabel
                }, "any"),
                locations.sort().map((x, k)=>/*#__PURE__*/ _jsx("option", {
                        value: x,
                        children: k
                    }, x))
            ]
        })
    }) : null;
    return /*#__PURE__*/ _jsx("section", {
        className: "search-bar cf",
        children: /*#__PURE__*/ _jsx("div", {
            className: "search-bar__wrapper",
            children: /*#__PURE__*/ _jsxs("fieldset", {
                className: "region-date",
                children: [
                    /*#__PURE__*/ _jsx("legend", {
                        className: "sr-text",
                        children: "Filter activiteiten op datum en plaats"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "region-date__inner",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "region-date__filter",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        className: "region-date__text",
                                        htmlFor: "rd-date",
                                        children: "Wanneer"
                                    }),
                                    periodFilter
                                ]
                            }),
                            locationFilterElement && /*#__PURE__*/ _jsxs("div", {
                                className: "region-date__filter",
                                children: [
                                    /*#__PURE__*/ _jsx("label", {
                                        className: "region-date__text",
                                        htmlFor: "rd-region",
                                        children: locationFilter.kind != 'none' ? locationFilter.heading : 'Waar'
                                    }),
                                    locationFilterElement
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
